// extracted by mini-css-extract-plugin
export default {"tab-bar":"TabBar_tab-bar__qEJPz","tabBar":"TabBar_tab-bar__qEJPz","tabs-wrapper":"TabBar_tabs-wrapper__R-2VK","tabsWrapper":"TabBar_tabs-wrapper__R-2VK"};